// extracted by mini-css-extract-plugin
module.exports = {"container":"product-gift-contents_container__d738N","divider":"product-gift-contents_divider__EPjL8"};